import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Total da NFe",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 3;
      }
    }
  }, [_c('b-row', {
    staticClass: "p-4"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 4
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "BC ICMS R$",
      "label-for": "baseICMS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "baseICMS",
      "name": "baseICMS"
    },
    model: {
      value: _vm.form.baseICMS,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "baseICMS", $$v);
      },
      expression: "form.baseICMS"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 4
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor do ICMS R$",
      "label-for": "valorICMS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "valorICMS",
      "name": "valorICMS"
    },
    model: {
      value: _vm.form.valorICMS,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valorICMS", $$v);
      },
      expression: "form.valorICMS"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 4
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "BC ICMS ST R$",
      "label-for": "baseICMSST"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "baseICMSST",
      "name": "baseICMSST"
    },
    model: {
      value: _vm.form.baseICMSST,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "baseICMSST", $$v);
      },
      expression: "form.baseICMSST"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 4
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor ICMS ST R$",
      "label-for": "valorICMSST"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "valorICMSST",
      "name": "valorICMSST"
    },
    model: {
      value: _vm.form.valorICMSST,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valorICMSST", $$v);
      },
      expression: "form.valorICMSST"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 4
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor IPI R$",
      "label-for": "valorIPI"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "valorIPI",
      "name": "valorIPI"
    },
    model: {
      value: _vm.form.valorIPI,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valorIPI", $$v);
      },
      expression: "form.valorIPI"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 4
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor do FCP ST R$",
      "label-for": "vFCPST"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "vFCPST",
      "name": "vFCPST"
    },
    model: {
      value: _vm.form.vFCPST,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vFCPST", $$v);
      },
      expression: "form.vFCPST"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 4
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor do FCP R$",
      "label-for": "vFCP"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "vFCP",
      "name": "vFCP"
    },
    model: {
      value: _vm.form.vFCP,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vFCP", $$v);
      },
      expression: "form.vFCP"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 4
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "ICMS Deso. R$",
      "label-for": "ICMSdesoneracao"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "ICMSdesoneracao",
      "name": "ICMSdesoneracao"
    },
    model: {
      value: _vm.form.ICMSdesoneracao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ICMSdesoneracao", $$v);
      },
      expression: "form.ICMSdesoneracao"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 4
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Total Produtos R$",
      "label-for": "totalProd"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "totalProd",
      "name": "totalProd",
      "disabled": ""
    },
    model: {
      value: _vm.form.totalProd,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "totalProd", $$v);
      },
      expression: "form.totalProd"
    }
  }, 'money', _vm.configMask, false))], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 2
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Frete R$",
      "label-for": "frete"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "frete",
      "name": "frete"
    },
    model: {
      value: _vm.form.freightPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "freightPrice", $$v);
      },
      expression: "form.freightPrice"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 2
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Seguro R$",
      "label-for": "seguro"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "seguro",
      "name": "seguro"
    },
    model: {
      value: _vm.form.insurance,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "insurance", $$v);
      },
      expression: "form.insurance"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 2
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Despesas R$",
      "label-for": "despesas"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "despesas",
      "name": "despesas"
    },
    model: {
      value: _vm.form.extraValue,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "extraValue", $$v);
      },
      expression: "form.extraValue"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 2
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Desconto R$",
      "label-for": "desconto"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.form.rateio_desconto,
      "id": "desconto",
      "name": "desconto"
    },
    model: {
      value: _vm.form.discount,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "discount", $$v);
      },
      expression: "form.discount"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 3
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Total da Nota R$",
      "label-for": "totalNFE"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "totalNFE",
      "name": "totalNFE",
      "disabled": ""
    },
    model: {
      value: _vm.total,
      callback: function callback($$v) {
        _vm.total = $$v;
      },
      expression: "total"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth < 768 ? 6 : 3
    }
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" Reteio do desconto nos itens: "), _c('b-icon', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: 'Ao selecionar essa opção irá fazer o reteio no itens',
      expression: "\n              'Ao selecionar essa opção irá fazer o reteio no itens'\n            "
    }],
    attrs: {
      "icon": "info-circle",
      "variant": "primary"
    }
  }), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.rateio_desconto,
      expression: "form.rateio_desconto"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.rateio_desconto) ? _vm._i(_vm.form.rateio_desconto, null) > -1 : _vm.form.rateio_desconto
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.rateio_desconto,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "rateio_desconto", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "rateio_desconto", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "rateio_desconto", $$c);
        }
      }
    }
  }), _c('span')])])], 1)])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };